import { hotjar } from 'react-hotjar';

const hjid = 3296984;
const hjsv = 6;

export const initializeHotjar = () => {
  hotjar.initialize(hjid, hjsv);
};
